<template>
    <div class="content">
        <div class="biaoqian">
             <p>实验标签</p>
             <el-radio-group v-model="radio1" @change="getlab" class="but">
                <el-radio-button label="" class="but2">全部</el-radio-button>
                <el-radio-button :label="item" v-for="(item,index) in biaoqianlist" :key="index" class="but2" v-show="item !== ''"></el-radio-button>
            </el-radio-group>
        </div>
        <!-- <div class="tese">
             <p>特色实验</p>
            <el-button size="mini" autofocus round @click="getcharacteristic('')">全部</el-button>
            <el-button size="mini" round v-for="(item,index) in teseList" :key="index" @click="getcharacteristic(item)">{{item}}</el-button>
        </div> -->
    </div>
</template>

<script>
import request from '@/utils/request'
export default {
    data(){
        return{
            radio1:'',
            biaoqianlist:[],
            // teseList:[]
        }
    },
    created(){
        this.getBiaoqianlist();
        // this.getTeselist();
    },
    methods:{
        getBiaoqianlist(){
            request({
                method:'get',
                url:'api/jdResources/ThemeType'
            }).then(res=>{
                this.biaoqianlist = res;
            })

        },
        // getTeselist(){
        //     request({
        //         method:'get',
        //         url:'api/jdResources/MaterialType'
        //     }).then(res=>{
        //         this.teseList = res;
        //     })

        // },
        getlab(item){
            this.bus.$emit("myFun1",item);
        },
        // getcharacteristic(item){
        //     this.bus.$emit("myFun2",item);
        // }
    }
    
}
</script>

<style scoped>
.content{
    width:300px;
    margin-top: 30px;
    margin-left: 30px;
    margin-bottom: 30px;
}
.content>div:after{
    display: block;
    width: 0;
    height: 0;
    content: "";
    clear: both;
}
.but2{
    float: left;
    margin-right: 15px;
    margin-top: 10px;
}
.biaoqian>p{
      font-weight: 600;
      color: #333;
      width:300px;
      font-size: 20px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
}
/* .tese>p{
    font-weight: 300;
    padding: 0 20px;
    font-size: 20px;
    line-height: 50px;
    margin: 0;
    margin-top: 30px;
    border-bottom: 1px solid #EBEEF5;
} */
  @media (max-width: 768px){
    .content{
        width:90%;
        margin-top: 30px;
        margin-left: 12px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
      font-weight: 600;
      color: #333;
      width:100%;
      font-size: 16px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
  @media screen and (min-width:769px) and (max-width: 1024px){
    .content{
        width:90%;
        margin-top: 30px;
        margin-left: 12px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
      font-weight: 600;
      color: #333;
      width:100%;
      font-size: 16px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .content{
        width:90%;
        margin-top: 30px;
        margin-left: 12px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
      font-weight: 600;
      color: #333;
      width:100%;
      font-size: 20px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
  @media screen and (min-width:1366px) and (max-width:1440px){
    .content{
        width:90%;
        margin-top: 30px;
        margin-left: 12px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
      font-weight: 600;
      color: #333;
      width:100%;
      font-size: 20px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    .content{
        width:90%;
        margin-top: 30px;
        margin-left: 12px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
      font-weight: 600;
      color: #333;
      width:100%;
      font-size: 20px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .content{
        width:300px;
        margin-top: 30px;
        margin-left: 30px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
        font-weight: 600;
        color: #333;
        width:300px;
        font-size: 20px;
        line-height: 39px;
        border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
  @media screen and (min-width:1921px) and (max-width:4096px){
    .content{
        width:90%;
        margin-top: 30px;
        margin-left: 12px;
        margin-bottom: 30px;
    }
    .biaoqian>p{
      font-weight: 600;
      color: #333;
      width:100%;
      font-size: 20px;
      line-height: 39px;
      border-bottom: 1px solid #f0f0f0;
    }
    /* 实验标签 */
    .biaoqian /deep/ .but2>.el-radio-button__inner{
        color: #666666;
        border-radius: 14px;
        padding: 8px;
        border: 1px solid #e6e6e6;
    }
    .biaoqian /deep/ .but2:first-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but:last-child .el-radio-button__inner{
        border-radius: 14px;
    }
    .biaoqian /deep/ .but2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color:#fff;
        background: #f1ad4e;
        border: none;
        border-radius: 14px;
        border: 1px solid #f1ad4e;
        box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/biaoqian.vue